// Shared time-window options for insights pages. `days: 0` means "all time".
// Used by the PeriodSelector control and to label the active window.
export const WINDOWS = [
  { days: 7, label: '7 days' },
  { days: 30, label: '30 days' },
  { days: 90, label: '90 days' },
  { days: 0, label: 'All time' },
] as const;

export function windowLabel(days: number): string {
  return WINDOWS.find((w) => w.days === days)?.label ?? '30 days';
}
